<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed } from "vue"
import { cn } from "@/shared/lib/utils"

const props = withDefaults(
  defineProps<{
    variant?: "destructive" | "info" | "warning"
    message?: string
    class?: HTMLAttributes["class"]
  }>(),
  { variant: "destructive" },
)

const variantClasses = computed(() => {
  switch (props.variant) {
    case "info":
      return "border-primary/50 bg-primary/10 text-primary"
    case "warning":
      return "border-muted-foreground/40 bg-muted text-foreground"
    default:
      return "border-destructive/50 bg-destructive/10 text-destructive"
  }
})
</script>

<template>
  <div
    :class="
      cn(
        'rounded-md border px-3 py-2 text-sm outline-none',
        variantClasses,
        props.class,
      )
    "
    role="alert"
    aria-live="assertive"
    tabindex="-1"
  >
    <slot>{{ message }}</slot>
  </div>
</template>
